import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, ChangeDetectorRef, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BaseComponent } from "components/base/base.component";
import { lastValueFrom } from "rxjs";
import { TemplateFiltroPadrao } from "src/app/shared/enums/filtro/TemplateFiltroPadrao";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { FiltroPadrao } from "src/app/shared/models/filtro-padrao/filtroPadrao";
import { AtribuicaoLoginSed } from "src/app/shared/models/sed/UserLogin";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { UtilsService } from 'src/app/shared/services/utils.service';
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { libsCommonImports } from "src/app/shared/ui/libs-common";
import { Funcionario } from "src/app/shared/models/envolvidos/funcionario";
import { FuncionarioService } from "src/app/shared/services/funcionarios.service";
import { Psicologo } from "src/app/shared/models/psicologo/Psicologo";
import { Municipio } from "src/app/shared/models/municipio/Municipio";
import { Polo } from "src/app/shared/models/polo/Polo";

@Component({
  selector: 'app-filtro-padrao',
  templateUrl: './filtro-padrao.component.html',
  styleUrls: ['./filtro-padrao.component.scss'],
  standalone: true,
  imports: [angularCommonImports, libsCommonImports]
})
export class FiltroPadraoComponent extends BaseComponent implements OnInit, OnChanges {
  @Output() filtroEmitter = new EventEmitter<FiltroPadrao>();
  @Output() diretoriaChange = new EventEmitter<number>();
  @Output() poloChange = new EventEmitter<number>();
  @Input() style: number = 1;
  @Input() template: TemplateFiltroPadrao = TemplateFiltroPadrao.Default;
  @Input() atividadeDE: boolean = false;
  @Input() psiInativos: boolean = false;
  @Input() listarPOC: boolean = false;
  @Input() listarPsicologo: boolean = false;
  @Input() usePolo: boolean = false;
  @Input() usePeriodo: boolean = false;
  @Input() useTurno: boolean = true;
  @Input() useAno: boolean = false;
  @Input() textoLupa: boolean = false;
  @Input() dividir2filas: boolean = false;
  @Input() escolaObrigatoria: boolean = true;
  @Input() anoObrigatorio: boolean = true;
  @Input() autoSubmitOnInit: boolean = true;
  /** CPF do psicólogo selecionado (gestor/coordenador no painel de atividades). */
  @Input() cpfPsicologoSelecionado: string | null = null;

  private atribuicoesPsicologoAtivas: AtribuicaoLoginSed[] = [];

  public get TemplateFiltroPadrao(): typeof TemplateFiltroPadrao {
    return TemplateFiltroPadrao;
  }

  constructor(
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  submitted: boolean = false;
  formFilter!: FormGroup;
  escolasDiretor: Escola[] = [];
  public listaPOC: Funcionario[] = [];
  public lstPsicologos: Psicologo[] = [];
  public municipios: Municipio[] = [];
  public carregandoCiclos = false;
  public carregandoPOC = false;
  private cicloSequencia = 0;
  private pocSequencia = 0;

  atividadeDiretoria: boolean = false;
  psicologosInativos: boolean = false;
  usuarioPossuiMultiplosPolos: boolean = false;
  public get form() { return this.formFilter.controls; }

  /** Diretor / Vice-Diretor: segregação por escola vinculada (#16736). */
  public isGestorEscolar(): boolean {
    const perfil = this.userLogado?.codigoPerfil;
    return perfil === Perfil.DiretorEscolar || perfil === Perfil.ViceDiretor;
  }

  ConvivaErrors = inject(ConvivaErrorHandlingService);
  public funcionarioService = inject(FuncionarioService);

  async ngOnInit(): Promise<void> {
    this.userLogado = this.authService.getUser();

    // Restaura escola vinculada se a sessão ficou com 0 e não estiver em "Atividade na URE"
    if (this.isGestorEscolar() && this.userLogado && !this.userLogado.apenasDiretoria) {
      this.restaurarEscolaVinculadaNaSessao();
    }

    // Preencher filtros com valores do login
    const codigoDiretoriaLogin = this.userLogado?.codigoDiretoria ?? null;
    const codigoEscolaLogin = this.userLogado?.codigoEscola ?? null;
    const codigoPoloLogin = this.userLogado?.codigoPolo ?? null;
    const atividadeDiretoriaLogin = this.userLogado?.apenasDiretoria ?? false;

    if (codigoEscolaLogin) {
      this.atividadeDiretoria = false;
    } else if (atividadeDiretoriaLogin) {
      this.atividadeDiretoria = true;
    } else if (this.isGestorEscolar()) {
      // Gestor: toggle disponível, mas não ativa sozinho quando escola veio zerada
      this.atividadeDiretoria = false;
    } else if (this.atividadeDE) {
      this.atividadeDiretoria = true;
    } else {
      this.atividadeDiretoria = false;
    }
    this.psicologosInativos = this.userLogado?.psicologosInativos ?? false;

    // Define validadores baseado nos inputs
    const escolaValidators = this.escolaObrigatoria
      ? [Validators.required]
      : [];
    const anoValidators = this.anoObrigatorio ? [Validators.required] : [];

    this.formFilter = new FormGroup({
      codigoPolo: new FormControl(null),
      codigoDiretoria: new FormControl(codigoDiretoriaLogin, [Validators.required]),
      codigoMunicipio: new FormControl(null),
      codigoEscola: new FormControl(codigoEscolaLogin, escolaValidators),
      codigoTurno: new FormControl(null),
      codigoTurma: new FormControl(null),
      codigoTipoEnsino: new FormControl(null),
      codigoPOC: new FormControl(null),
      anoAtual: new FormControl(new Date().getFullYear(), anoValidators), // MODIFICADO
      fpDataInicio: new FormControl(null),
      fpDataFim: new FormControl(null),
      codigoCPF: new FormControl(null),
    });

    // Carregar polos antes de setar o valor (somente quando o filtro exibe polo)
    let poloSelecionado: number | null = null;
    const diretoriaParaPolos = this.diretoriaParaConsultaDePolos(codigoDiretoriaLogin);
    if (this.usePolo && diretoriaParaPolos) {
      const responsePolos = await lastValueFrom(this.psicologoService.getPolos(diretoriaParaPolos)).catch(() => null);
      if (responsePolos && responsePolos.isSucess && Array.isArray(responsePolos.data) && responsePolos.data.length > 0) {
        this.polos = responsePolos.data.map((p: any) => ({ ...p, codigoPolo: Number(p.codigoPolo) }));
        if (codigoPoloLogin && !this.ehCoordenadorPsicologo()) {
          const codigoPoloNumber = Number(codigoPoloLogin);
          let found = this.polos.find((p: any) => Number(p.codigoPolo) === codigoPoloNumber);
          if (!found) {
            this.polos = [
              { codigoPolo: codigoPoloNumber, descricaoPolo: 'Polo do Login' },
              ...this.polos
            ];
          }
          this.formFilter.get('codigoPolo')?.setValue(codigoPoloNumber);
          this.formFilter.get('codigoPolo')?.updateValueAndValidity();
          this.cdr.markForCheck();
          poloSelecionado = codigoPoloNumber;
        } else if (this.ehCoordenadorPsicologo()) {
          const codigoPoloNumber = Number(codigoPoloLogin ?? 0);
          const found = this.polos.find((p: any) => Number(p.codigoPolo) === codigoPoloNumber);
          const codigoPolo = found ? codigoPoloNumber : Number(this.polos[0].codigoPolo);
          this.formFilter.get('codigoPolo')?.setValue(codigoPolo);
          this.formFilter.get('codigoPolo')?.updateValueAndValidity();
          this.cdr.markForCheck();
          poloSelecionado = codigoPolo;
        } else {
          // Se não veio polo do login e só existe um polo, preenche automaticamente
          if (this.polos.length === 1) {
            this.formFilter.get('codigoPolo')?.setValue(this.polos[0].codigoPolo);
            this.formFilter.get('codigoPolo')?.updateValueAndValidity();
            this.cdr.markForCheck();
            poloSelecionado = this.polos[0].codigoPolo;
          }
        }
      }
    }

    // Não sobrescrever escola ou atividadeDiretoria se vierem do login
    this.verificaApenasDiretoria();
    await this.UserBehavior();
    await this.activeDiretoria();

    // #177878 — não recolocar URE/polo de fora do vínculo do coordenador psicólogo
    if (codigoDiretoriaLogin && this.diretoriaPodeSerAplicada(Number(codigoDiretoriaLogin))) {
      this.formFilter.get('codigoDiretoria')?.setValue(codigoDiretoriaLogin);
    }
    if (codigoEscolaLogin) {
      this.formFilter.get('codigoEscola')?.setValue(codigoEscolaLogin);
      if (this.useTurno) {
        await this.getTurnos();
      }
    }

    // Reforça o valor do polo após todos os carregamentos
    if (this.usePolo && poloSelecionado !== null && this.poloPodeSerAplicado(Number(poloSelecionado))) {
      this.formFilter.get('codigoPolo')?.setValue(poloSelecionado);
      this.formFilter.get('codigoPolo')?.updateValueAndValidity();
      this.cdr.markForCheck();
    }

    const polo = this.formFilter.get('codigoPolo')?.value
    if (this.listarPsicologo && polo > 0 && this.template == TemplateFiltroPadrao.PEC) {
      await this.getPsicologosPolo(polo);
    }

    // se diretoria selecionada e lista vazia, tenta novamente
    if (
      this.form.codigoDiretoria.value &&
      (!this.escolas || this.escolas.length === 0)
    ) {
      await this.getEscolas(this.form.codigoDiretoria.value);
      if (this.listarPOC) {
        void this.getPOCPorDiretoria(false);
      }
    }

    if (
      this.autoSubmitOnInit &&
      (
        (this.template == TemplateFiltroPadrao.Default &&
          this.userLogado?.codigoDiretoria &&
          (this.userLogado.codigoEscola || this.atividadeDiretoria)) ||
        (this.template == TemplateFiltroPadrao.Polo && polo && this.userLogado?.codigoDiretoria) ||
        (this.template == TemplateFiltroPadrao.PEC && this.userLogado?.codigoDiretoria) ||
        (this.template == TemplateFiltroPadrao.HomePEC && this.userLogado?.codigoDiretoria)
      )
    ) {
      this.onSubmit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cpfPsicologoSelecionado'] && !changes['cpfPsicologoSelecionado'].firstChange) {
      void this.carregarDiretorias();
    }
  }

  private async carregarDiretorias(): Promise<void> {
    this.atribuicoesPsicologoAtivas = [];

    const codigoPolo = Number(
      this.formFilter?.get('codigoPolo')?.value ??
      this.userLogado?.codigoPolo ??
      0
    );

    if (codigoPolo > 0) {
      await this.getDiretoriasPorPolo();
    }
  }

  public async UserBehavior() {
    if (this.template == TemplateFiltroPadrao.Default) {
      if (this.userLogado?.flPsicologo) {
        await this.getDiretoriasPerfilPsicologo();
      } else {
        if (this.atribuicoesLogin.NumeroComportamento == 1) {
          await this.getDiretoriasAdmin();
        }

        if (this.atribuicoesLogin.NumeroComportamento == 2) {
          await this.getDiretoriasPerfilDiretoria();
        }

        if (
          this.atribuicoesLogin.NumeroComportamento == 3 ||
          this.atribuicoesLogin.NumeroComportamento == 4
        ) {
          await this.getDiretoriasPerfilEscola();
        }
      }
    } else if (this.template == TemplateFiltroPadrao.Polo) {
      if (this.userLogado?.flPsicologo) {
        await this.getPoloDiretoriaPsicologo();
      } else {
        if (this.atribuicoesLogin.NumeroComportamento == 1) {
          await this.getPolosAdmin();
        }
        if (this.atribuicoesLogin.NumeroComportamento == 2) {
          await this.getPolosPerfilDiretor();
        }
        if (
          this.atribuicoesLogin.NumeroComportamento == 3 ||
          this.atribuicoesLogin.NumeroComportamento == 4
        ) {
          await this.getPolosPerfilProfessor();
        }
      }
    } else if (this.template == TemplateFiltroPadrao.PEC) {
      // if (this.userLogado?.flPsicologo) {
      //   await this.getPoloDiretoriaPsicologo();
      // }
      // else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getPolosAdmin();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getPolosPerfilDiretor();
      }
      if (
        this.atribuicoesLogin.NumeroComportamento == 3 ||
        this.atribuicoesLogin.NumeroComportamento == 4
      ) {
        await this.getPolosPerfilProfessor();
      }
      //}
    } else if (this.template == TemplateFiltroPadrao.HomePEC) {
      // if (this.userLogado?.flPsicologo) {
      //   await this.getPoloDiretoriaPsicologo();
      // }
      // else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getPolosAdmin();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getPolosPerfilDiretor();
      }
      if (
        this.atribuicoesLogin.NumeroComportamento == 3 ||
        this.atribuicoesLogin.NumeroComportamento == 4
      ) {
        await this.getPolosPerfilProfessor();
      }
      //}
    }

    this.disableVoidInputs();
    await this.activeDiretoria();
  }

  // LISTA AS DIRETORIAS QUE O USUÝRIO TEM ACESSO DE ACORDO COM O COMPORTAMENTO DELE
  private async getDiretoriasPerfilPsicologo() {
    await this.aplicarDiretoriasAtribuidasPsicologo(Number(this.userLogado!.codigoPolo), this.userLogado!.cpf);
  }

  public async getDiretoriasAdmin() {
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.escolaService.getDiretoriaPorTipoDiretoria(),
    ).catch((err) => {
      return this.convivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();
  }

  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];
    this.spinnerService.show();

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      let diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);
    });

    if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.disable();
    }

    this.spinnerService.hide();
  }

  public getDiretoriasPerfilEscola() {
    this.diretorias = [];
    this.escolas = [];
    this.spinnerService.show();

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;

      this.escolas.push(escola);
    });

    this.escolasDiretor = [...this.escolas];

    if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.disable();
    }
    this.spinnerService.hide();
  }

  public async OnChangeDiretoriaHomePEC(codigoDiretoria: number) {
    this.spinnerService.show();

    this.municipios = [];
    this.form.codigoMunicipio?.setValue(null);
    this.zerarEscola();
    this.zerarPOC();
    this.form.codigoTipoEnsino?.setValue(null);
    this.tipoEnsinos = [];

    try {
      const response = await lastValueFrom(
        this.escolaService.getMunicipiosPorDiretoria(codigoDiretoria),
      );
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }
      this.municipios = response.data;
      this.form.codigoMunicipio.enable();

      if (this.listarPOC) {
        void this.getPOCPorDiretoria(false);
      }

      void this.activeCiclos(codigoDiretoria, null, false);
    } catch (err) {
      this.toastr.error('Erro ao carregar municípios');
      console.error(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  public async OnChangeMunicipio() {
    const codigoMunicipio = this.form.codigoMunicipio.value;
    const codigoDiretoria = this.form.codigoDiretoria.value;
    if (!codigoMunicipio) {
      this.zerarEscola();
      return;
    }

    this.spinnerService.show();
    this.escolas = [];
    try {
      const response = await lastValueFrom(
        this.escolaService.getEscolasPorMunicipio(
          codigoMunicipio,
          codigoDiretoria,
        ),
      );
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }
      this.escolas = response.data;
      this.form.codigoEscola.enable();
    } catch (err) {
      this.toastr.error('Erro ao carregar escolas');
      console.error(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  //LISTA AS ESCOLAS DE ACORDO COM A DIRETORIA
  public async getEscolas(codigoDiretoria: number | null = null) {
    this.spinnerService.show();

    this.escolas = [];
    this.form.codigoEscola.patchValue(null);
    if (this.atividadeDiretoria) {
      this.form.codigoEscola.disable();
    }

    if (this.deveCarregarTodasEscolasDiretoria() && codigoDiretoria != null) {
      this.zerarEscola();

      const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDiretoria))
        .catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.escolas = response.data;
      await this.activeEscola();
      this.atividadeDiretoria ? this.form.codigoEscola.disable() : this.form.codigoEscola.enable();

      if (this.userLogado) {
        this.userLogado.codigoDiretoria = this.form.codigoDiretoria.value;
        if (!this.userLogado.apenasDiretoria) {
          this.userLogado.codigoEscola = this.form.codigoEscola.value;
        }
        this.authService.setUser(this.userLogado);
      }

      this.spinnerService.hide();
      return;
    }

    if (this.deveFiltrarPorAtribuicoesPsicologo() && codigoDiretoria != null) {
      await this.carregarEscolasAtribuidasPsicologo(codigoDiretoria);
      this.spinnerService.hide();
      return;
    }

    if (codigoDiretoria != null && this.diretoriaChange.observed) {
      this.diretoriaChange.emit(codigoDiretoria);
      this.zerarEscola();

      this.spinnerService.show();

      var response = await lastValueFrom(
        this.escolaService.getEscolasPorCodigoDiretoria(codigoDiretoria!),
      );

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.escolas = response.data;
      await this.activeEscola();
      // this.diretorias = response.data.diretorias;
      this.atividadeDiretoria
        ? this.form.codigoEscola.disable()
        : this.form.codigoEscola.enable();
      this.spinnerService.hide();
    }

    if (this.atribuicoesLogin.NumeroComportamento == 1 ||
      this.atribuicoesLogin.NumeroComportamento == 2) {
      this.zerarEscola();

      if (codigoDiretoria != null) {
        var response = await lastValueFrom(
          this.escolaService.getEscolasPorCodigoDiretoria(codigoDiretoria),
        ).catch((err) => {
          return this.convivaErrors.handleResultError(err);
        });

        if (!response.isSucess) {
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }

        this.form.codigoEscola.enable();
        this.escolas = response.data;
        await this.activeEscola();
      }
    } else if (
      this.atribuicoesLogin.NumeroComportamento == 3 ||
      this.atribuicoesLogin.NumeroComportamento == 4
    ) {
      this.zerarEscola();
      if (codigoDiretoria != null) {
        // usa snapshot independente
        this.userLogado?.DadosUsuario?.filter(
          (x) => x.CodigoDiretoria == this.form.codigoDiretoria.value,
        ).map((item: AtribuicaoLoginSed) => {
          const escola = new Escola();
          escola.codigoEscola = item.CodigoEscola;
          escola.nomeEscola = item.NomeEscola;
          escola.codigoDiretoria = item.CodigoDiretoria;

          this.escolas.push(escola);
        });

        if (this.escolas.length > 0) {
          this.form.codigoEscola.enable();
          await this.activeEscola();
          if (this.atividadeDiretoria) {
            this.form.codigoEscola.setValue(null);
            this.form.codigoEscola.disable();
          } else if (this.isGestorEscolar() || this.escolas.length == 1) {
            const codigoEscolaTravada = this.obterCodigoEscolaVinculada(codigoDiretoria)
              || this.escolas[0].codigoEscola;
            this.form.codigoEscola.setValue(codigoEscolaTravada);
            this.form.codigoEscola.disable();
            if (this.userLogado) {
              this.userLogado.codigoEscola = codigoEscolaTravada;
              this.userLogado.apenasDiretoria = false;
              this.authService.setEscola(codigoEscolaTravada);
            }
          }
        } else {
          this.form.codigoEscola.disable(); // evita ficar “vazio habilitado”
        }
      } else {
        this.form.codigoEscola.disable();
      }
    }

    if (this.userLogado) {
      this.userLogado.codigoDiretoria = this.form.codigoDiretoria.value;
      if (!this.userLogado.apenasDiretoria) {
        const codigoEscolaForm = this.form.codigoEscola.value;
        if (codigoEscolaForm) {
          this.userLogado.codigoEscola = codigoEscolaForm;
          this.authService.setEscola(codigoEscolaForm);
        } else if (!this.isGestorEscolar()) {
          this.userLogado.codigoEscola = codigoEscolaForm;
        }
      }
      this.authService.setUser(this.userLogado);
    }
    this.spinnerService.hide();
  }

  public zerarEscola() {
    this.escolas = [];
    this.form.codigoEscola.patchValue(null);
    this.form.codigoEscola.disable();
  }

  public async getTurmas(
    codigoEscola: number | null = null,
    codigoTurno: number | null = null,
  ) {
    this.spinnerService.show();
    this.turmas = [];
    this.form.codigoTurma.setValue(null);
    this.form.codigoTurma.disable();
    if (codigoEscola && codigoTurno) {
      var response = await lastValueFrom(
        this.escolaService.getTurmasPorCodigoCie(codigoEscola, codigoTurno),
      ).catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.turmas = response.data;
      this.form.codigoTurma.enable();
    }
    this.spinnerService.hide();
  }

  public async getTurnos() {
    this.zerarTurnos();
    this.zerarTurmas();

    sessionStorage.setItem(
      'painelPsicologo_codigoEscola',
      this.form.codigoEscola.value,
    );

    if (this.form.codigoEscola.value) {
      this.spinnerService.show();

      const result = await lastValueFrom(
        this.escolaService.getTurnosPorCodigoCie(this.form.codigoEscola.value),
      ).catch((err) => {
        return this.convivaErrors.handleResultError(err);
      });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.turnos = result?.data;
      this.form.codigoTurno.enable();
      if (this.turnos == null || this.turnos == undefined)
        this.toastr.warning('Não foi encontrados turnos para essa escola !');

      if (this.turnos.filter((u) => u.codigoTurno == 0).length > 0) {
        this.form.codigoTurno.setValue(0);
        await this.getTurmas();
      }

      this.spinnerService.hide();
    }

    if (this.userLogado) {
      if (!this.userLogado.apenasDiretoria) {
        const codigoEscolaForm = this.form.codigoEscola.value;
        if (codigoEscolaForm) {
          this.userLogado.codigoEscola = codigoEscolaForm;
          this.authService.setEscola(codigoEscolaForm);
        } else if (!this.isGestorEscolar()) {
          this.userLogado.codigoEscola = 0;
        }
      }
      this.authService.setUser(this.userLogado);
    }
  }

  public zerarTurnos() {
    this.turnos = [];
    this.form.codigoTurno.patchValue(null);
    this.form.codigoTurno.disable();
  }

  public zerarTurmas() {
    this.turmas = [];
    this.form.codigoTurma.patchValue(null);
    this.form.codigoTurma.disable();
  }

  onSubmit() {
    if (this.formInvalid()) {
      this.submitted = true;
      return;
    }

    this.setFilters();
    this.filtroEmitter.emit(this.filtros);
  }

  setFilters() {
    this.filtros = new FiltroPadrao();
    this.filtros.codigoDiretoria = this.form.codigoDiretoria.value;
    this.filtros.codigoEscola = this.form.codigoEscola.value;
    this.filtros.codigoTurno = this.form.codigoTurno.value;
    this.filtros.codigoTurma = this.form.codigoTurma.value;
    this.filtros.anoAtual = this.form.anoAtual.value;
    this.filtros.codigoPolo = this.usePolo ? this.form.codigoPolo.value : undefined;
    this.filtros.codigoPOC = this.form.codigoPOC.value;
    this.filtros.atividadeDiretoria = this.atividadeDiretoria;
    this.filtros.psicologosInativos = this.psicologosInativos;
    this.filtros.codigoTipoEnsino = this.form.codigoTipoEnsino.value;
    this.filtros.fpDataInicio = this.form.fpDataInicio.value;
    this.filtros.fpDataFim = this.form.fpDataFim.value;
    this.filtros.cpf = this.form.codigoCPF.value;
    this.filtros.codigoMunicipio = this.form.codigoMunicipio.value;

    const escolaSelecionada = this.escolas.find(
      (e) => e.codigoEscola === this.filtros.codigoEscola,
    );
    this.filtros.codigoTipoIdentificador =
      escolaSelecionada?.codigoTipoIdentificador;
    this.filtros.nomePolo = this.usePolo
      ? (this.polos.find(p => p.codigoPolo === this.filtros.codigoPolo)?.descricaoPolo ?? '')
      : '';
    this.filtros.nomeDiretoria = this.diretorias.find(d => d.codigoDiretoria === this.filtros.codigoDiretoria)?.nomeDiretoria ?? '';
    this.filtros.nomeEscola = escolaSelecionada?.nomeEscola ?? '';
    this.filtros.nomeMunicipio = this.municipios.find(m => m.codigoMunicipio === this.filtros.codigoMunicipio)?.nomeMunicipio ?? '';
    this.filtros.nomePOC = this.listaPOC.find(p => p.cpf === String(this.filtros.codigoPOC ?? ''))?.nome ?? '';

    this.filtros.nomeTipoEnsino =
      this.tipoEnsinos.find(
        (x) =>
          x.codigoTipoEnsino === this.formFilter.get('codigoTipoEnsino')?.value,
      )?.nomeTipoEnsino ?? '';
  }

  async activeDiretoria() {
    if (this.diretorias != undefined && this.userLogado?.codigoDiretoria != 0) {
      const diretoria = this.diretorias.find(
        (s) => s.codigoDiretoria == this.userLogado?.codigoDiretoria,
      );
      if (diretoria) {
        this.form.codigoDiretoria.setValue(
          Number(this.userLogado?.codigoDiretoria),
        );
        this.form.codigoDiretoria.enable();

        if (this.template == TemplateFiltroPadrao.PEC || this.template == TemplateFiltroPadrao.HomePEC) {
          void this.activeCiclos(this.form.codigoDiretoria.value, null, false);
        }

        if (this.template == TemplateFiltroPadrao.HomePEC) {
          await this.OnChangeDiretoriaHomePEC(this.form.codigoDiretoria.value);
        }

        await this.getEscolas(this.form.codigoDiretoria.value);
      }
    }
  }

  async activeEscola() {
    let _codigoEscola: string | null = sessionStorage.getItem('painelPsicologo_codigoEscola');
    if (
      this.escolas != undefined &&
      this.userLogado?.codigoEscola != 0 &&
      !this.atividadeDiretoria
    ) {
      const escola = this.escolas.find(
        (s) => s.codigoEscola == this.userLogado?.codigoEscola,
      );
      if (escola) {
        this.form.codigoEscola.setValue(Number(this.userLogado?.codigoEscola));
        if (this.useTurno) {
          await this.getTurnos();
        }

        if (this.template == TemplateFiltroPadrao.PEC || this.template == TemplateFiltroPadrao.HomePEC) {
          void this.activeCiclos(this.form.codigoDiretoria.value, this.userLogado?.codigoEscola, false);
        }
      }
    } else if (_codigoEscola != "null") {
      if (_codigoEscola != '0') {
        this.form.codigoEscola.setValue(Number(_codigoEscola));

        this.userLogado = this.authService.getUser();
        if (this.userLogado) {
          this.userLogado.codigoEscola = Number(_codigoEscola);
        }

        if (this.useTurno) {
          await this.getTurnos();
        }
      }
    } else if (!this.atividadeDiretoria) {
        this.form.codigoEscola.setValue(Number(_codigoEscola));

        this.userLogado = this.authService.getUser();
        if (this.userLogado && !this.userLogado.apenasDiretoria) {
          this.userLogado.codigoEscola = Number(_codigoEscola);
        }

        if (this.useTurno) {
          await this.getTurnos();
        }
    }

    if (
      this.template != TemplateFiltroPadrao.PEC &&
      this.template != TemplateFiltroPadrao.HomePEC &&
      this.form.codigoEscola?.value &&
      this.form.codigoDiretoria?.value &&
      this.form.codigoPolo?.value &&
      (this.atribuicoesLogin.NumeroComportamento == 2 ||
        this.atribuicoesLogin.NumeroComportamento == 3)
    ) {
      this.filtros = new FiltroPadrao();
      this.filtros.codigoEscola = this.form.codigoEscola?.value;
      this.filtros.codigoDiretoria = this.form.codigoDiretoria?.value;
      this.filtros.codigoPolo = this.form.codigoPolo?.value;
      this.filtroEmitter.emit(this.filtros);
    }
  }

  disableVoidInputs() {
    // if(this.template == TemplateFiltroPadrao.Polo){
    //   this.form.codigoDiretoria.setValue(null);
    //   this.form.codigoDiretoria.disable();
    // }
    this.form.codigoEscola.setValue(null);
    this.form.codigoEscola.disable();
    this.form.codigoTurno.setValue(null);
    this.form.codigoTurno.disable();
    this.form.codigoTurma.setValue(null);
    this.form.codigoTurma.disable();
  }

  formInvalid(): boolean {
    const nrComportamento = String(
      this.userLogado?.NumeroComportamento ??
        this.atribuicoesLogin.NumeroComportamento,
    );

    if (nrComportamento === '1') {
      this.form.codigoDiretoria.setErrors(null);
      this.form.codigoEscola.setErrors(null);
      return this.formFilter.invalid;
    }

    if (nrComportamento === '2') {
      this.form.codigoEscola.setValidators(null);
      this.form.codigoEscola.updateValueAndValidity();
      return this.formFilter.invalid;
    }

    if (nrComportamento === '3' || nrComportamento === '4') {
      this.form.codigoEscola.setValidators(null);
      this.form.codigoEscola.updateValueAndValidity();
      return this.formFilter.invalid;
    }

    return true;
  }

  public async OnChangePolo() {
    const codigoPolo = Number(this.formFilter.get('codigoPolo')?.value ?? 0);
    const manterDiretoriaCoordenador = this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo
      ? Number(this.userLogado?.codigoDiretoria ?? 0)
      : 0;

    if (this.userLogado) {
      this.userLogado.codigoPolo = codigoPolo > 0 ? codigoPolo : 0;
      this.userLogado.codigoDiretoria = manterDiretoriaCoordenador;
      this.userLogado.codigoEscola = 0;
      this.authService.setUser(this.userLogado);
    }

    // limpa URE/Escola sempre que trocar polo
    this.formFilter.get('codigoDiretoria')?.setValue(null);
    this.formFilter.get('codigoEscola')?.setValue(null);
    this.zerarDiretoria();
    this.zerarEscola();

    if (codigoPolo > 0) {
      this.poloChange.emit(codigoPolo);
      await this.getDiretoriasPorPolo();

      if (this.listarPsicologo && this.template == TemplateFiltroPadrao.PEC) {
        await this.getPsicologosPolo(codigoPolo);
      }

      if (this.ehCoordenadorPsicologo()) {
        this.onSubmit();
      }
    }
  }

  public async onChangeDiretoriaPolo(): Promise<void> {
    const codigoDiretoria = Number(this.form.codigoDiretoria.value ?? 0);
    await this.getEscolas(codigoDiretoria > 0 ? codigoDiretoria : null);

    if (this.ehCoordenadorPsicologo()) {
      this.onSubmit();
    }
  }

  public async getPsicologosPolo(codigoPolo: number) {
    // Origem Polo 1 = Login do usuário, Origem Polo 2 = Filtro de pesquisa
    this.spinnerService.show();

    var response = await lastValueFrom(
      this.psicologoService.getPsicologosPorPolo(codigoPolo),
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();

    this.lstPsicologos = response.data;

    for (let item of this.lstPsicologos) {
      item.nomePsicologoCompleto = `${item.codigoCPF} - ${item.nomePsicologo}`;
    }
  }

  public zerarDiretoria() {
    this.diretorias = [];
    this.form.codigoDiretoria.patchValue(null);
    this.form.codigoDiretoria.disable();
  }

  public async getDiretoriasPorPolo(diretoriaLogada: boolean = false) {
    if (this.ehCoordenadorPsicologo() && this.userLogado) {
      const poloFormulario = Number(this.form?.codigoPolo?.value ?? 0);
      const poloUsuario = Number(this.userLogado.codigoPolo ?? 0);
      const poloFormularioValido = this.polos?.some((p) => Number(p.codigoPolo) === poloFormulario) ?? false;
      const poloUsuarioValido = this.polos?.some((p) => Number(p.codigoPolo) === poloUsuario) ?? false;
      const codigoPolo = poloFormularioValido
        ? poloFormulario
        : (poloUsuarioValido ? poloUsuario : Number(this.polos?.[0]?.codigoPolo ?? 0));

      if (codigoPolo > 0) {
        this.userLogado.codigoPolo = codigoPolo;
        this.form?.codigoPolo?.setValue(codigoPolo, { emitEvent: false });
        await this.aplicarDiretoriasVinculadasCoordenador(codigoPolo);
      }
      return;
    }

    if (this.userLogado?.codigoPolo) {
      if (this.deveFiltrarPorAtribuicoesPsicologo()) {
        await this.aplicarDiretoriasAtribuidasPsicologo(
          Number(this.userLogado.codigoPolo),
          this.obterCpfPsicologoParaFiltroUre()
        );
        return;
      }

      if (
        this.atribuicoesLogin?.NumeroComportamento == 1 ||
        this.atribuicoesLogin?.NumeroComportamento == 2
      ) {
        this.zerarDiretoria();
        this.spinnerService.show();

        const response = await lastValueFrom(
          this.psicologoService.getDiretoriaPorPolo(this.userLogado.codigoPolo)
        ).catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

        if (!response.isSucess) {
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }

        this.diretorias = response.data;
        this.form.codigoDiretoria.enable();
        this.ativaDiretoria();
        this.getEscolasPorDiretoria();

        if (this.listarPOC) {
          void this.getPOCPorDiretoria(false);
        }

        this.spinnerService.hide();
      } else if (
        this.atribuicoesLogin?.NumeroComportamento == 3 ||
        this.atribuicoesLogin?.NumeroComportamento == 4
      ) {
        const codigoPoloSelecionado = Number(this.userLogado?.codigoPolo ?? 0);

        const todasDiretorias: Diretoria[] = [];
        this.diretorias = [];
        this.form.codigoDiretoria.setValue(null);

        this.userLogado?.DadosUsuario.forEach(item => {
          const diretoria = new Diretoria();
          diretoria.codigoDiretoria = item.CodigoDiretoria;
          diretoria.nomeDiretoria = item.NomeDiretoria;
          diretoria.codigoPolo = item.CodigoPolo;
          todasDiretorias.push(diretoria);
        });

        // REGRA: somente UREs do polo selecionado
        this.diretorias = todasDiretorias
          .filter(d => Number(d.codigoPolo) === codigoPoloSelecionado)
          .filter((d, i, arr) => arr.findIndex(x => x.codigoDiretoria === d.codigoDiretoria) === i);

        if (this.diretorias.length === 1) {
          this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
          this.form.codigoDiretoria.disable();
          await this.getEscolas(this.diretorias[0].codigoDiretoria);
        } else if (this.diretorias.length > 1) {
          this.form.codigoDiretoria.enable();
        } else {
          this.form.codigoDiretoria.disable();
        }
      }

      if (this.userLogado !== null) {
        this.userLogado.codigoDiretoria =
          this.form.codigoDiretoria.value == null ? 0 : this.form.codigoDiretoria.value;
        this.authService.setUser(this.userLogado);
      }
    }
  }

  public ativaDiretoria() {
    const diretoria = this.diretorias.filter(
      (s) => s.codigoDiretoria == this.userLogado?.codigoDiretoria,
    );

    if (
      this.userLogado?.codigoDiretoria &&
      this.userLogado?.codigoDiretoria > 0 &&
      diretoria.length > 0
    ) {
      this.formFilter
        .get('codigoDiretoria')
        ?.setValue(this.userLogado?.codigoDiretoria);
    }

    const polo = this.polos.filter(
      (s) => s.codigoPolo == this.userLogado?.codigoPolo,
    );
    if (
      this.userLogado?.codigoPolo &&
      this.userLogado?.codigoPolo > 0 &&
      polo.length > 0
    ) {
      this.formFilter.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);
    }
  }

  public async getPolosAdmin() {
    this.spinnerService.show();
    var response = await lastValueFrom(this.psicologoService.getPolos());

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    // Filtra polos vinculados ao usuário logado
    if (this.userLogado?.DadosUsuario && this.userLogado.DadosUsuario.length > 0) {
      const polosUsuario = [...new Set(this.userLogado.DadosUsuario.map(x => x.CodigoPolo))].filter(p => p > 0);
      this.polos = polosUsuario.length > 0
        ? response.data.filter((p: any) => polosUsuario.includes(p.codigoPolo))
        : response.data;
    } else {
      this.polos = response.data;
    }
    this.spinnerService.hide();

    this.ativaPolo();
    if (this.userLogado?.codigoPolo && this.userLogado.codigoPolo != 0) {
      await this.getDiretoriasPorPolo(true);
    } else if (!this.diretorias?.length && this.userLogado?.codigoDiretoria) {
      await this.getDiretoriasAdmin();
    }
    this.spinnerService.hide();
  }

  public ativaPolo() {
    const controlPolo = this.formFilter.get('codigoPolo');
    if (!controlPolo) return;

    if (!this.polos || this.polos.length === 0) {
      controlPolo.setValue(null);
      controlPolo.enable();
      return;
    }

    if (this.polos.length === 1) {
      const codigoPoloUnico = Number(this.polos[0].codigoPolo);
      controlPolo.setValue(codigoPoloUnico);
      controlPolo.disable();

      if (this.userLogado) {
        this.userLogado.codigoPolo = codigoPoloUnico;
        this.authService.setUser(this.userLogado);
      }

      return;
    }

    const codigoAtual = Number(this.userLogado?.codigoPolo ?? 0);
    const codigoValido = this.polos.some(p => Number(p.codigoPolo) === codigoAtual);

    controlPolo.enable();
    controlPolo.setValue(codigoValido ? codigoAtual : null);
  }

  public async getPolosPerfilDiretor() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getPolos()).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.aplicarRegraPolos(response.data);

    if (this.ehCoordenadorPsicologo()) {
      await this.carregarUresDoCoordenadorNoPoloSelecionado();
      this.spinnerService.hide();
      return;
    }

    // só mantém fluxo antigo quando tiver 1 polo
    if (this.polos.length === 1 && this.userLogado?.DadosUsuario[0].CodigoDiretoria != 0) {

      const todasDiretoriasDoUsuario: Diretoria[] = [];
      this.userLogado?.DadosUsuario.forEach(item => {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        todasDiretoriasDoUsuario.push(diretoria);
      });

      this.diretorias = todasDiretoriasDoUsuario;

      if (this.diretorias.length == 1) {
        this.form.codigoDiretoria.setValue(this.userLogado?.DadosUsuario[0].CodigoDiretoria);
      } else {
        this.form.codigoDiretoria.enable();
      }

      this.form.codigoEscola.enable();
      await this.getEscolasPorDiretoria();

      if (this.listarPOC) {
        void this.getPOCPorDiretoria(false);
      }

      this.poloChange.emit(this.polos[0].codigoPolo);
    }

    this.spinnerService.hide();
  }

  public async getEscolasPorDiretoria(inicio = false) {
    if (this.userLogado !== null && !inicio) {
      this.userLogado.codigoEscola =
        this.form.codigoDiretoria.value == null
          ? 0
          : this.userLogado.codigoEscola;
      this.authService.setUser(this.userLogado);
    }
    if (inicio && this.userLogado?.codigoDiretoria && this.userLogado.codigoDiretoria > 0) {
      this.form.codigoDiretoria.setValue(this.userLogado.codigoDiretoria);
    }

    if (this.form.codigoDiretoria.value) {
      this.spinnerService.show();
      this.zerarEscola();
      var response = await lastValueFrom(
        this.escolaService.getEscolasPorCodigoDiretoria(
          this.form.codigoDiretoria.value,
        ),
      ).catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.escolas = response.data;
      this.ativaEscola();
      // this.getEscolasPorDiretoria();
      this.spinnerService.hide();
    }
  }

  public ativaEscola() {
    let _codigoEscola = sessionStorage.getItem('painelPsicologo_codigoEscola');
    if (
      this.escolas != undefined &&
      this.userLogado?.codigoEscola != 0 &&
      !this.userLogado?.apenasDiretoria
    ) {
      const escola = this.escolas.find(
        (s) => s.codigoEscola == this.userLogado?.codigoEscola,
      );
      if (escola != undefined) {
        this.formFilter
          .get('codigoEscola')
          ?.setValue(this.userLogado?.codigoEscola);
        this.formFilter.get('codigoEscola')?.enable();
      }
    } else if (_codigoEscola != "null" && !this.userLogado?.apenasDiretoria) {
      if (_codigoEscola != "0") {
        this.formFilter.get('codigoEscola')?.setValue(_codigoEscola);
        this.formFilter.get('codigoEscola')?.enable();

        this.userLogado = this.authService.getUser();

        if (this.userLogado && !this.userLogado.apenasDiretoria) {
          this.userLogado.codigoEscola = Number(_codigoEscola);
        }
      }
    }
  }

  public async getPolosPerfilProfessor() {
    this.spinnerService.show();

    // Para coordenador: buscar todos e filtrar pelos polos vinculados no próprio componente
    const response = await lastValueFrom(this.psicologoService.getPolos()).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.aplicarRegraPolos(response.data); // aplica filtro por vínculo + habilita/desabilita corretamente

    if (this.ehCoordenadorPsicologo()) {
      await this.carregarUresDoCoordenadorNoPoloSelecionado();
      this.spinnerService.hide();
      return;
    }

    if (this.polos.length === 1) {
      // comportamento atual para 1 polo
      await this.OnChangePolo();
    } else {
      // múltiplos polos: garantir habilitado
      this.form.codigoPolo.enable({ emitEvent: false });

      const codigoAtual = Number(this.userLogado?.codigoPolo ?? 0);
      const poloValido = this.polos.some(p => Number(p.codigoPolo) === codigoAtual);
      this.form.codigoPolo.setValue(poloValido ? codigoAtual : null, { emitEvent: false });

      // limpa URE/Escola até escolher o polo
      this.zerarDiretoria();
      this.zerarEscola();
    }

    this.spinnerService.hide();
  }

  private ehCoordenadorPsicologo(): boolean {
    return this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo;
  }

  private diretoriaParaConsultaDePolos(codigoDiretoriaLogin: number | null): number | number[] | null {
    if (!this.ehCoordenadorPsicologo()) {
      return codigoDiretoriaLogin;
    }

    const vinculos = this.codigosDiretoriaVinculadasCoordenador();
    if (vinculos.length === 0) {
      return codigoDiretoriaLogin;
    }

    return vinculos;
  }

  private diretoriaPodeSerAplicada(codigoDiretoria: number): boolean {
    if (!this.ehCoordenadorPsicologo()) {
      return true;
    }

    return this.diretorias?.some((d) => Number(d.codigoDiretoria) === Number(codigoDiretoria)) ?? false;
  }

  private poloPodeSerAplicado(codigoPolo: number): boolean {
    if (!this.ehCoordenadorPsicologo()) {
      return true;
    }

    return this.polos?.some((p) => Number(p.codigoPolo) === Number(codigoPolo)) ?? false;
  }

  private async carregarUresDoCoordenadorNoPoloSelecionado(): Promise<void> {
    const poloAtual = Number(this.form.codigoPolo.value ?? 0);
    const poloValido = this.polos.some((p) => Number(p.codigoPolo) === poloAtual);
    const codigoPolo = poloValido ? poloAtual : Number(this.polos[0]?.codigoPolo ?? 0);

    if (codigoPolo <= 0 || !this.userLogado) {
      this.zerarDiretoria();
      return;
    }

    this.form.codigoPolo.setValue(codigoPolo, { emitEvent: false });
    this.userLogado.codigoPolo = codigoPolo;
    await this.aplicarDiretoriasVinculadasCoordenador(codigoPolo);
  }

  private normalizarDiretoria(item: any): Diretoria {
    const diretoria = new Diretoria();
    diretoria.codigoDiretoria = Number(item?.codigoDiretoria ?? item?.CodigoDiretoria ?? 0);
    diretoria.nomeDiretoria = item?.nomeDiretoria ?? item?.NomeDiretoria ?? '';
    const codigoPolo = Number(item?.codigoPolo ?? item?.CodigoPolo ?? 0);
    if (codigoPolo > 0) {
      diretoria.codigoPolo = codigoPolo;
    }
    return diretoria;
  }

  private codigosDiretoriaVinculadasCoordenador(): number[] {
    const codigos = (this.userLogado?.DadosUsuario ?? [])
      .map((d: any) => Number(d?.CodigoDiretoria ?? d?.codigoDiretoria ?? 0))
      .filter((codigo) => codigo > 0);

    return [...new Set(codigos)];
  }

  private async aplicarDiretoriasVinculadasCoordenador(codigoPolo: number) {
    this.zerarDiretoria();
    this.spinnerService.show();

    const vinculos = new Set(this.codigosDiretoriaVinculadasCoordenador());
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPolo))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    const diretoriasPolo: Diretoria[] = (response?.isSucess ? (response.data ?? []) : [])
      .map((item: any) => this.normalizarDiretoria(item))
      .filter((d: Diretoria) => d.codigoDiretoria > 0);
    let diretorias = diretoriasPolo.filter((d) => vinculos.has(Number(d.codigoDiretoria)));

    if (diretorias.length === 0 && vinculos.size > 0 && diretoriasPolo.length === 0) {
      const nomes = new Map<number, string>();
      for (const item of this.userLogado?.DadosUsuario ?? []) {
        const codigo = Number((item as any).CodigoDiretoria ?? (item as any).codigoDiretoria ?? 0);
        const nome = (item as any).NomeDiretoria ?? (item as any).nomeDiretoria ?? '';
        if (codigo > 0 && !nomes.has(codigo)) {
          nomes.set(codigo, nome);
        }
      }
      diretorias = [...vinculos].map((codigo) => {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = codigo;
        diretoria.nomeDiretoria = nomes.get(codigo) ?? '';
        return diretoria;
      });
    }

    this.diretorias = diretorias;

    if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      await this.getEscolas(this.diretorias[0].codigoDiretoria);
    } else if (this.diretorias.length > 1) {
      const atual = Number(this.userLogado?.codigoDiretoria ?? 0);
      const selecionada = this.diretorias.some((d) => Number(d.codigoDiretoria) === atual)
        ? atual
        : Number(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.setValue(selecionada);
      this.form.codigoDiretoria.enable();
    } else {
      this.form.codigoDiretoria.disable();
      this.toastr.warning('Nenhuma URE vinculada ao coordenador foi encontrada neste polo.');
    }

    if (this.userLogado !== null) {
      const codigoSelecionado = Number(this.form.codigoDiretoria.value ?? 0);
      const pertenceAoVinculo = this.diretorias.some((d) => Number(d.codigoDiretoria) === codigoSelecionado);
      this.userLogado.codigoDiretoria = pertenceAoVinculo ? codigoSelecionado : 0;
      this.authService.setUser(this.userLogado);
    }

    this.spinnerService.hide();
  }

  private obterCpfPsicologoParaFiltroUre(): string {
    const cpfSelecionado = this.cpfPsicologoSelecionado?.replace(/\D/g, '') ?? '';
    if (cpfSelecionado.length > 0) {
      return cpfSelecionado;
    }
    return this.userLogado?.cpf?.replace(/\D/g, '') ?? '';
  }

  private deveFiltrarPorAtribuicoesPsicologo(): boolean {
    if (this.userLogado?.flPsicologo) {
      return true;
    }
    const cpf = this.cpfPsicologoSelecionado?.replace(/\D/g, '') ?? '';
    return cpf.length >= 11;
  }

  private deveCarregarTodasEscolasDiretoria(): boolean {
    return this.userLogado?.flPsicologo === true
      || this.userLogado?.codigoPerfil === Perfil.Psicólogo;
  }

  private async garantirAtribuicoesPsicologo(cpf: string): Promise<AtribuicaoLoginSed[]> {
    const cpfNormalizado = cpf.replace(/\D/g, '');
    if (!cpfNormalizado) {
      return [];
    }

    if (this.atribuicoesPsicologoAtivas.length > 0
      && this.atribuicoesPsicologoAtivas[0]?.Cpf?.toString().replace(/\D/g, '') === cpfNormalizado) {
      return this.atribuicoesPsicologoAtivas;
    }

    const response = await lastValueFrom(this.psicologoService.getPsicologoAtribuicoesPorCpf(cpfNormalizado))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (response?.isSucess) {
      const escolas = response.data?.escolas ?? response.data?.Escolas ?? [];
      const novosDados: AtribuicaoLoginSed[] = [];

      for (const item of escolas) {
        const codigoDiretoria = item.codigoDiretoria ?? item.CodigoDiretoria;
        const poloResponse = await lastValueFrom(this.psicologoService.getPolos(codigoDiretoria))
          .catch(() => null);

        const atribuicao = new AtribuicaoLoginSed();
        atribuicao.CodigoDiretoria = codigoDiretoria;
        atribuicao.NomeDiretoria = item.nomeDiretoria ?? item.NomeDiretoria;
        atribuicao.CodigoEscola = item.codigoEscola ?? item.CodigoEscola;
        atribuicao.NomeEscola = item.nomeEscola ?? item.NomeEscola;
        atribuicao.CodigoPolo = poloResponse?.data?.[0]?.codigoPolo ?? 0;
        atribuicao.Cpf = Number(cpfNormalizado);
        novosDados.push(atribuicao);
      }

      if (novosDados.length > 0) {
        this.atribuicoesPsicologoAtivas = novosDados;
        return novosDados;
      }
    } else {
      this.toastr.error(response?.message ?? 'Não foi possível carregar as atribuições do psicólogo na SED.');
    }

    if (this.userLogado?.flPsicologo && cpfNormalizado === (this.userLogado.cpf?.replace(/\D/g, '') ?? '')) {
      const doLogin = this.userLogado.DadosUsuario?.filter((d) => d.CodigoDiretoria > 0 && d.CodigoEscola > 0) ?? [];
      if (doLogin.length > 0) {
        this.atribuicoesPsicologoAtivas = doLogin;
        return doLogin;
      }
    }

    return [];
  }

  private async aplicarDiretoriasAtribuidasPsicologo(codigoPolo: number, cpf: string) {
    this.zerarDiretoria();
    this.spinnerService.show();

    const atribuicoes = await this.garantirAtribuicoesPsicologo(cpf);
    if (!atribuicoes.length) {
      this.spinnerService.hide();
      return;
    }

    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPolo))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? 'Erro ao carregar UREs do polo.');
      this.spinnerService.hide();
      return;
    }

    const codigosAtribuidos = new Set(
      atribuicoes
        .filter((d) => Number(d.CodigoPolo) === Number(codigoPolo) && d.CodigoDiretoria > 0)
        .map((d) => d.CodigoDiretoria)
    );

    const diretoriasPolo = response.data ?? [];
    this.diretorias = codigosAtribuidos.size > 0
      ? diretoriasPolo.filter((d: Diretoria) => codigosAtribuidos.has(d.codigoDiretoria))
      : diretoriasPolo.filter((d: Diretoria) =>
        atribuicoes.some((a) => a.CodigoDiretoria === d.codigoDiretoria)
      );

    if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      await this.getEscolas(this.diretorias[0].codigoDiretoria);
    } else if (this.diretorias.length > 1) {
      this.form.codigoDiretoria.enable();
    } else {
      this.form.codigoDiretoria.disable();
      this.toastr.warning('Nenhuma URE ativa encontrada na SED para este polo.');
    }

    if (this.userLogado !== null) {
      this.userLogado.codigoDiretoria =
        this.form.codigoDiretoria.value == null ? 0 : this.form.codigoDiretoria.value;
      this.authService.setUser(this.userLogado);
    }

    this.spinnerService.hide();
  }

  private async carregarEscolasAtribuidasPsicologo(codigoDiretoria: number) {
    this.zerarEscola();

    const cpf = this.obterCpfPsicologoParaFiltroUre();
    const atribuicoes = await this.garantirAtribuicoesPsicologo(cpf);

    atribuicoes
      .filter((item) => item.CodigoDiretoria === codigoDiretoria && item.CodigoEscola > 0)
      .forEach((item) => {
        const escola = new Escola();
        escola.codigoEscola = item.CodigoEscola;
        escola.nomeEscola = item.NomeEscola;
        escola.codigoDiretoria = item.CodigoDiretoria;
        this.escolas.push(escola);
      });

    if (this.escolas.length > 0) {
      this.form.codigoEscola.enable();
      await this.activeEscola();
      if (this.escolas.length === 1) {
        this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
        this.form.codigoEscola.disable();
      }
    } else {
      this.form.codigoEscola.disable();
    }

    if (this.userLogado) {
      this.userLogado.codigoDiretoria = this.form.codigoDiretoria.value;
      if (!this.userLogado.apenasDiretoria) {
        this.userLogado.codigoEscola = this.form.codigoEscola.value;
      }
      this.authService.setUser(this.userLogado);
    }
  }

  public async getPoloDiretoriaPsicologo() {
    const response = await lastValueFrom(
      this.psicologoService.getPoloPsicologo(this.userLogado!.cpf)
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    // aceita retorno objeto único ou lista
    const polosRetorno = Array.isArray(response.data) ? response.data : [response.data];
    this.polos = polosRetorno.filter((p: any) => Number(p?.codigoPolo) > 0);

    if (this.polos.length === 1) {
      // comportamento atual (um polo): seleciona e bloqueia
      this.form.codigoPolo.setValue(this.polos[0].codigoPolo);
      this.form.codigoPolo.disable();

      if (this.userLogado) {
        this.userLogado.codigoPolo = this.polos[0].codigoPolo;
        this.authService.setUser(this.userLogado);
      }

      await this.getDiretoriasPorPolo();
      return;
    }

    // mais de um polo: habilita seleção
    this.form.codigoPolo.enable();

    const codigoAtual = Number(this.userLogado?.codigoPolo ?? 0);
    const codigoValido = this.polos.some((p: any) => Number(p.codigoPolo) === codigoAtual);

    this.form.codigoPolo.setValue(codigoValido ? codigoAtual : null);

    // só carrega URE após escolha do polo
    this.zerarDiretoria();
    this.zerarEscola();
  }

  public verificaApenasDiretoria() {
    if (this.atividadeDiretoria) {
      this.form.codigoEscola.clearValidators();
      this.form.codigoEscola.setValue(null);
    } else {
      if (this.escolaObrigatoria) {
        this.form.codigoEscola.setValidators([Validators.required]);
      } else {
        this.form.codigoEscola.clearValidators();
      }
      // Não sobrescrever valor da escola nem de atividadeDiretoria
    }
    this.form.codigoEscola.updateValueAndValidity();
  }

  public OnChangeApenasDiretoria() {
    this.atividadeDiretoria = !this.atividadeDiretoria;

    if (this.atividadeDiretoria) {
      this.form.codigoEscola.clearValidators();
      this.form.codigoEscola.setValue(null);
      this.form.codigoEscola.disable();
    } else {
      if (this.escolaObrigatoria) {
        this.form.codigoEscola.setValidators([Validators.required]);
      } else {
        this.form.codigoEscola.clearValidators();
      this.userLogado!.apenasDiretoria = true;
      this.userLogado!.codigoEscola = 0;
      }
      this.form.codigoEscola.enable();
      this.userLogado!.apenasDiretoria = false;

      if (this.isGestorEscolar()) {
        const codigoEscola = this.obterCodigoEscolaVinculada(this.form.codigoDiretoria.value)
          || this.escolas[0]?.codigoEscola;
        if (codigoEscola) {
          this.form.codigoEscola.setValue(codigoEscola);
          this.form.codigoEscola.disable();
          this.userLogado!.codigoEscola = codigoEscola;
          this.authService.setEscola(codigoEscola);
        }
      }
    }

    this.form.codigoEscola.updateValueAndValidity();
    this.authService.setUser(this.userLogado!);

  }

  private obterCodigoEscolaVinculada(codigoDiretoria?: number | null): number {
    if (!this.userLogado) {
      return 0;
    }

    if (this.userLogado.codigoEscola && this.userLogado.codigoEscola > 0) {
      const existeNaLista = !this.escolas?.length
        || this.escolas.some(e => e.codigoEscola === this.userLogado!.codigoEscola);
      if (existeNaLista) {
        return this.userLogado.codigoEscola;
      }
    }

    const atribuicoes = this.userLogado.DadosUsuario ?? [];
    const filtradas = codigoDiretoria
      ? atribuicoes.filter(a => a.CodigoDiretoria === codigoDiretoria)
      : atribuicoes;
    const comEscola = filtradas.find(a => a.CodigoEscola > 0);
    return comEscola?.CodigoEscola ?? 0;
  }

  private restaurarEscolaVinculadaNaSessao(): void {
    if (!this.userLogado) {
      return;
    }

    if (this.userLogado.codigoEscola && this.userLogado.codigoEscola > 0) {
      this.userLogado.apenasDiretoria = false;
      this.authService.setUser(this.userLogado);
      this.authService.setEscola(this.userLogado.codigoEscola);
      return;
    }

    const codigoDiretoria = (this.userLogado.codigoDiretoria ?? 0) > 0
      ? this.userLogado.codigoDiretoria
      : this.userLogado.DadosUsuario?.[0]?.CodigoDiretoria;
    const codigoEscola = this.obterCodigoEscolaVinculada(codigoDiretoria);

    if (codigoEscola > 0) {
      this.userLogado.codigoEscola = codigoEscola;
      if (codigoDiretoria) {
        this.userLogado.codigoDiretoria = codigoDiretoria;
      }
      this.userLogado.apenasDiretoria = false;
      this.authService.setUser(this.userLogado);
      this.authService.setEscola(codigoEscola);
    }
  }

  public OnChangePsicologosInativos() {
    this.psicologosInativos = !this.psicologosInativos;
    this.userLogado!.psicologosInativos = this.psicologosInativos;
    this.authService.setUser(this.userLogado!);

    if (this.ehCoordenadorPsicologo() && Number(this.form.codigoDiretoria.value) > 0) {
      this.onSubmit();
    }
  }

  getLabelEscola() {
    const valor = this.form.codigoEscola.value;
    const item = this.escolas.find((op) => op.codigoEscola === valor);
    return item?.nomeEscola ?? '';
  }
  getLabelDiretoria() {
    const valor = this.form.codigoDiretoria.value;
    const item = this.diretorias.find((op) => op.codigoDiretoria === valor);
    return item?.nomeDiretoria ?? '';
  }

  // LISTA OS CICLOS (TIPOS DE ENSINO)
  public async activeCiclos(
    codigoDiretoria: number | null = null,
    codigoEscola: number | null = null,
    usarSpinnerGlobal = true
  ) {
    const sequencia = ++this.cicloSequencia;

    if (usarSpinnerGlobal) {
      this.spinnerService.show();
    } else {
      this.carregandoCiclos = true;
      this.form.codigoTipoEnsino.disable();
    }

    this.zerarTurnos();

    // Limpa lista e reseta campo do formulário
    this.tipoEnsinos = [];
    this.form.codigoTipoEnsino.patchValue(null);

    // Atribui 0 se os valores forem null ou undefined
    let _codigoDiretoria = codigoDiretoria ?? 0;
    let _codigoEscola = codigoEscola ?? 0;

    try {
      const response = await lastValueFrom(
        this.tipoEnsinoService.getTiposEnsinos(_codigoDiretoria, _codigoEscola),
      );

      if (sequencia !== this.cicloSequencia) {
        return;
      }

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.form.codigoTipoEnsino.disable();
        return;
      }

      this.tipoEnsinos = response.data;

      if (this.tipoEnsinos.length > 0) {
        this.form.codigoTipoEnsino.enable();
      } else {
        this.form.codigoTipoEnsino.disable();
      }
    } catch (err) {
      if (sequencia === this.cicloSequencia) {
        this.toastr.error('Erro ao carregar os ciclos.');
        console.error(err);
        this.form.codigoTipoEnsino.disable();
      }
    } finally {
      if (sequencia === this.cicloSequencia) {
        if (usarSpinnerGlobal) {
          this.spinnerService.hide();
        } else {
          this.carregandoCiclos = false;
        }
        this.cdr.markForCheck();
      }
    }
  }

  public async getPOCPorDiretoria(usarSpinnerGlobal = true) {
    const codigoDiretoria = this.form.codigoDiretoria.value;

    if (!codigoDiretoria) {
      this.zerarPOC();
      return;
    }

    const sequencia = ++this.pocSequencia;

    if (usarSpinnerGlobal) {
      this.spinnerService.show();
    } else {
      this.carregandoPOC = true;
    }

    this.zerarPOC();

    try {
      var response = await lastValueFrom(this.funcionarioService.getPOCPorDiretoria(codigoDiretoria))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (sequencia !== this.pocSequencia) {
        return;
      }

      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }
      this.listaPOC = response.data;

      if (this.listaPOC.length > 0) {
        this.form.codigoPOC.enable();
      } else {
        this.form.codigoPOC.disable();
      }
    } finally {
      if (sequencia === this.pocSequencia) {
        if (usarSpinnerGlobal) {
          this.spinnerService.hide();
        } else {
          this.carregandoPOC = false;
        }
        this.cdr.markForCheck();
      }
    }
  }

  public zerarPOC() {
    this.listaPOC = [];
    this.form.codigoPOC.patchValue(null);
    this.form.codigoPOC.disable();
  }

  private obterCodigosPolosVinculadosUsuario(): number[] {
    const dadosUsuario = this.userLogado?.DadosUsuario ?? [];

    const codigosDosDados = dadosUsuario
      .flatMap((item: any) => {
        const polosInternos =
          item?.Polos ??
          item?.polos ??
          item?.ListaPolos ??
          item?.listaPolos;

        if (Array.isArray(polosInternos) && polosInternos.length > 0) {
          return polosInternos;
        }

        return [item];
      })
      .map((item: any) =>
        Number(
          item?.CodigoPolo ??
          item?.codigoPolo ??
          item?.CdPolo ??
          item?.cdPolo ??
          item?.Polo?.CodigoPolo ??
          item?.polo?.codigoPolo ??
          0
        )
      )
      .filter((codigo: number) => codigo > 0);

    // IMPORTANTE:
    // se não veio vínculo em DadosUsuario, NÃO restringe por codigoPolo do login
    // (senão derruba para 1 polo e trava o campo).
    if (codigosDosDados.length === 0) {
      return [];
    }

    const codigoPoloLogin = Number(this.userLogado?.codigoPolo ?? 0);
    if (codigoPoloLogin > 0 && (!this.ehCoordenadorPsicologo() || codigosDosDados.includes(codigoPoloLogin))) {
      codigosDosDados.push(codigoPoloLogin);
    }

    return [...new Set(codigosDosDados)];
  }

  private aplicarRegraPolos(polosRetornados: Polo[]): void {
    const codigosVinculados = this.obterCodigosPolosVinculadosUsuario();

    this.polos = (polosRetornados ?? []).filter((p: Polo) =>
      codigosVinculados.length === 0 || codigosVinculados.includes(Number(p.codigoPolo))
    );

    this.usuarioPossuiMultiplosPolos = this.polos.length > 1;

    // garante estado correto do controle sempre
    const ctrl = this.formFilter.get('codigoPolo');
    if (ctrl) {
      if (this.polos.length > 1) {
        ctrl.enable({ emitEvent: false });
      } else if (this.polos.length === 1) {
        ctrl.setValue(this.polos[0].codigoPolo, { emitEvent: false });
        ctrl.disable({ emitEvent: false });
      } else {
        ctrl.setValue(null, { emitEvent: false });
        ctrl.enable({ emitEvent: false });
      }
    }
  }

}
